<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12rx2dM/tc-custom/9781480462571.jpg?1733105255047" alt="This image is the cover for the book Everybody's Somebody's Fool, The Sam McCain Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everybody's Somebody's Fool, The Sam McCain Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>There is a body in a gazebo, and the chief suspect is not long for this world</b><br/>Small-town lawyer and private detective Sam McCain is enjoying a cocktail party, dancing with a lovelier specimen than his five-foot-five-inch frame usually attracts, when the hostess confronts him with a problem the likes of which <i>Good Housekeeping </i>has never seen. There is a corpse in the backyard gazebo, and the party is definitely over.<br/>The murdered girl was the twenty-year-old daughter of the town’s Cadillac dealer, a troubled young woman with a self-destructive streak. The police focus their investigation on her drag-racing boyfriend, local bad boy David Egan, whom McCain agrees to defend. When Egan dies in a freak car accident, the case seems closed. But examining the hot rod shows a cut brake line—and a motive for a killing far more complicated than good girl gone bad.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ed Gorman
      </h2>
      
      <p class="authorDescription body article">Ed Gorman (b. 1941) is an American author best known for writing mystery novels. After two decades in advertising, he began publishing novels in the mid-1980s. While using the pen name Daniel Ransom to write popular horror stories like&#160;<i>Daddy&rsquo;s Little Girl&#160;</i>(1985) and&#160;<i>Toys in the Attic</i>&#160;(1986), he published more ambitious work under his own name, starting with&#160;<i>Rough Cut</i>&#160;(1986). A story about murder and intrigue inside the advertising world, it was based on his own experience, and introduced Midwestern private detective Jack Dwyer, a compassionate sleuth with a taste for acting.<BR>Gorman&rsquo;s other series characters include Robert Payne, a psychological profiler, and Leo Guild, a bounty hunter of the Old West, but his best-known character is probably Sam McCain, a gentle young sleuth of the 1950s, who first appeared in&#160;<i>The Day the Music Died</i>&#160;(1998). Besides writing novels, Gorman is a cofounder of&#160;<i>Mystery Scene</i>&#160;magazine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c298b0a